import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const helpData = {
  BusTicketHelp: [
    {
      question: "How to book a bus ticket?",
      answer: `Please follow the below steps for booking bus ticket:

• Click on Bus ticket icon.

• Select “Origin and Destination”.

• Select “Date of Journey”.

• Click on “Search Buses”.

• You will get all available buses for the selected route. 
  - Select the Seat
  - Choose Boarding Point & Dropping Point
  - Enter Passenger Details and Mobile Number

• Go to the payment section and click “Proceed”.

• You will receive confirmation status of your booking to the mobile number entered during booking.`,
    },
    {
      question: "Cancellation Policy in Bus tickets?",
      answer: `Cancellation Policy:

• The cancellation terms are shown while booking and on the ticket printout/Email confirmation.

• Tickets booked online must be cancelled online only.

• Cancellation charges apply on original fare, not on discounted fare.

• Service Fee/GST is non-refundable.

• Refunds are processed automatically after cancellation. It may take 5–14 days for the amount to reflect in your bank/card.

• Refunds are credited to the same bank account/card used during booking.

Cancellation Table (for a ₹790 ticket):
Time Before Travel      | Deduction % | Amount Deducted
------------------------|-------------|----------------
3 days before           | 10%         | ₹79
1 day before            | 10%         | ₹79
4 hours before          | 10%         | ₹79
3 hours before          | 30%         | ₹237
2 hours before          | 100%        | ₹790
Last 2 hours            | 100%        | ₹790`,
    },
    {
      question:
        "I am unable to book ticket successfully. What should I do now?",
      answer:
        "Please take a screenshot of the error message and share it with us at: support@taipl.in",
    },
  ],
};

const BusTicketHelp = ({ selectedSection = "LoadMoney" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Bustickets.jpg"
          alt="Profile illustration"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* FAQ Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          BusTicket Help
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default BusTicketHelp;
